import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';

export interface JobRecurringMeta {
  /** Escalation-rule summary, e.g. "3% / year" or "CPI (US-CPI)". */
  escalation: string | null;
  /** Tax-jurisdiction label, e.g. "Austin, TX · 8.25%". */
  taxLabel: string | null;
}

/**
 * §8 — soft display facts for the recurring detail (escalation + tax label) that
 * aren't on the raw job row; kept off the hot findById projection.
 */
export function useJobRecurringMeta(jobId: string, enabled = true) {
  return useApiQuery<JobRecurringMeta>({
    queryKey: [...jobKeys.detail(jobId), 'recurring-meta'],
    queryFn: () => apiGet<JobRecurringMeta>(operationsClient, jobEndpoints.recurringMeta(jobId)),
    enabled: Boolean(jobId) && enabled,
    showErrorToast: false,
  });
}
